// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import { listProductSlice, productDetailsSlice } from "./features/Product/productSlice";
import { cartSlice } from "./features/Cart/cartSlice";
import { orderCreateSlice, orderDetailsSlice, orderListMySlice } from "./features/Order/orderSlice";
import reviewReducer from "./features/Product/reviewSlice";
import authReducer from "./features/Auth/authSlice";

const userInfoFromLocalStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const cartItemsFromLocalStorage = localStorage.getItem("cartItems")
  ? JSON.parse(localStorage.getItem("cartItems"))
  : [];

const shippingAddressFromLocalStorage = localStorage.getItem("shippingAddress")
  ? JSON.parse(localStorage.getItem("shippingAddress"))
  : {};

const paymentMethodFromLocalStorage = localStorage.getItem("paymentMethod")
  ? JSON.parse(localStorage.getItem("paymentMethod"))
  : "";

const rootReducer = {
  listProduct: listProductSlice.reducer,
  productDetails: productDetailsSlice.reducer,
  cart: cartSlice.reducer,
  auth: authReducer,  // ✅ جایگزین userLogin, userRegister, userDetails, userUpdateProfile
  orderCreate: orderCreateSlice.reducer,
  orderDetails: orderDetailsSlice.reducer,
  orderListMy: orderListMySlice.reducer,
  reviews: reviewReducer,
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState: {
    cart: {
      cartItems: cartItemsFromLocalStorage,
      shippingAddress: shippingAddressFromLocalStorage,
      paymentMethod: paymentMethodFromLocalStorage,
    },
    auth: {
      userInfo: userInfoFromLocalStorage,
      phone: "",
      isNewUser: false,
      otpSent: false,
      loading: false,
      error: null,
    },
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;